"use client";

import { LOADING_INDICATOR_COPY } from "./loading-indicator.copy";

/**
 * O original chamava `useLinkStatus` do `next/link` direto — hook exclusivo
 * do Next, que só funciona dentro da árvore de um `<Link>`. O pacote não
 * importa Next, então quem descobre o `pending` é o adaptador do app
 * (`apps/web/src/components/ui/loading-indicator.tsx`), e aqui só sobra a
 * apresentação.
 */
export type LoadingIndicatorProps = {
  pending: boolean;
};

export function LoadingIndicator({ pending }: LoadingIndicatorProps) {
  return pending ? (
    <div
      role="status"
      aria-label={LOADING_INDICATOR_COPY.loading}
      className="fixed top-0 left-0 z-50 h-[2px] w-full animate-pulse bg-primary"
    />
  ) : null;
}
